// extracted by mini-css-extract-plugin
export default {"Choice":"Choice_Choice__B0c7Z","correct":"Choice_correct__9WSY7","wrong":"Choice_wrong__e-LRn","fa":"Choice_fa__3hxMI"};